import Api from '../Api';

import { url } from './config';
import { Client } from './model';

const api = new Api<Client>(url);

export default api;
